import React from 'react';
import { useTranslation } from 'react-i18next';
import { DOLD_GROUP_WEBSITE_URL, IGP_WEBSITE_URL, RELEASE_NAME } from '../../core/config';
import { Link } from '../link/link';
import { Typography } from '../typography/typography';
import { Spacer } from '../spacer/spacer';
import IgpLogo from './assets/igp-powder-coatings-logo.svg?react';
import styles from './footer.module.scss';

export const Footer: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.outerContainer}>
      <div className={styles.innerContainer}>
        <div className={styles.footer}>
          <div className={styles.logoContainer}>
            <IgpLogo className={styles.logo} />
          </div>
          <div className={styles.contentContainer}>
            <div className={styles.infoContainer}>
              <Typography variant="maintext">
                IGP Pulvertechnik AG
                <br />
                Ringstrasse 30
                <br />
                9500 Wil · Schweiz
              </Typography>
              <div className={styles.contactContainer}>
                <Link icon="phone" to="tel:+41719298111">
                  +41 71 929 81 11
                </Link>
                <Link icon="mail" to="mailto:powder-center@igp-powder.com">
                  powder-center@igp-powder.com
                </Link>
                <Link icon="house" rel="noopener noreferrer" target="_blank" to={IGP_WEBSITE_URL}>
                  igp-powder.com
                </Link>
              </div>
            </div>
            <div className={styles.linkContainer}>
              <div className={styles.linkGroup}>
                <Link rel="noopener noreferrer" target="_blank" to={t('global.imprint.linkTo')} variant="footer">
                  {t('global.imprint')}
                </Link>
                <Link rel="noopener noreferrer" target="_blank" to={t('global.dataProtection.linkTo')} variant="footer">
                  {t('global.dataProtection')}
                </Link>
                <Link
                  rel="noopener noreferrer"
                  target="_blank"
                  to={t('global.termsAndConditions.linkTo')}
                  variant="footer"
                >
                  {t('global.termsAndConditions')}
                </Link>
              </div>
              <div className={styles.linkGroup}>
                <Link rel="noopener noreferrer" target="_blank" to={t('global.aboutUs.linkTo')} variant="footer">
                  {t('global.aboutUs')}
                </Link>
                <Link rel="noopener noreferrer" target="_blank" to={t('global.contact.linkTo')} variant="footer">
                  {t('global.contact')}
                </Link>
                <Link rel="noopener noreferrer" target="_blank" to={t('global.career.linkTo')} variant="footer">
                  {t('global.career')}
                </Link>
              </div>
            </div>
          </div>
          <div className={styles.additionalInformation}>
            <Typography>{t('footer.aCompanyOfThe')}</Typography>
            <Link rel="noopener noreferrer" target="_blank" to={DOLD_GROUP_WEBSITE_URL}>
              DOLD GROUP
            </Link>
          </div>
          <Spacer size="03" />
          <Typography color="anthrazit-50" variant="smalltext">
            Release {RELEASE_NAME}
          </Typography>
        </div>
      </div>
    </div>
  );
};
